export const vijaywadaEvent = [
    {
        "tiff_name": "Sentinel1_2024-10-07",
        "display_name": "Sentinel1_2024-10-07",
        "vmin": -25,
        "vmax": 0,
        // "cmap_colors": ['#000000', '#FFFFFF'],
        "colormap_name": "gray",
        "rescale": "-25,0",
        "gcs_url": "https://storage.googleapis.com/tile-server-bucket/vijaywada-event-1/Sentinel1_2024-10-07.tif",
        "bounds": [80.56698665126918, 16.48649975218137, 80.7054224601241, 16.59340995058957]
    },
    {
        "tiff_name": "Sentinel1_2024-09-01",
        "display_name": "Sentinel1_2024-09-01",
        "vmin": -25,
        "vmax": 0,
        // "cmap_colors": ['#000000', '#FFFFFF'],
        "colormap_name": "gray",
        "rescale": "-25,0",
        "gcs_url": "https://storage.googleapis.com/tile-server-bucket/vijaywada-event-1/Sentinel1_2024-09-01.tif",
        "bounds": [80.56698665126918, 16.48649975218137, 80.7054224601241, 16.59340995058957]
    },
    {
        "tiff_name": "Sentinel1_2024-08-20",
        "display_name": "Sentinel1_2024-08-20",
        "vmin": -25,
        "vmax": 0,
        // "cmap_colors": ['#000000', '#FFFFFF'],
        "colormap_name": "gray",
        "rescale": "-25,0",
        "gcs_url": "https://storage.googleapis.com/tile-server-bucket/vijaywada-event-1/Sentinel1_2024-08-20.tif",
        "bounds": [80.56698665126918, 16.48649975218137, 80.7054224601241, 16.59340995058957]
    },
    {
        "tiff_name": "twi_rank_order",
        "display_name": "twi_rank_order",
        // "vmin": 1,
        // "vmax": 59,
        // "cmap_colors": ['#0000FF', '#00FFFF', '#FFFF00', '#FFA500', '#FF0000'],
        "colormap": { "0": "#FFFFFF", "255": "#0000FF" },
        "gcs_url": "https://storage.googleapis.com/tile-server-bucket/vijaywada-event-1/twi_rank_order.tif",
        "bounds": [80.56698665126918, 16.48649975218137, 80.7054224601241, 16.59340995058957]
    },
    {
        "tiff_name": "inundation_rank_order",
        "display_name": "inundation_rank_order",
        // "vmin": 1,
        // "vmax": 59,
        // "cmap_colors": ['#0000FF', '#00FFFF', '#FFFF00', '#FFA500', '#FF0000'],
        "colormap": { "0": "#FFFFFF", "255": "#0000FF" },
        "gcs_url": "https://storage.googleapis.com/tile-server-bucket/vijaywada-event-1/inundation_rank_order.tif",
        "bounds": [80.56698665126918, 16.48649975218137, 80.7054224601241, 16.59340995058957]
    },
    {
        "tiff_name": "building_inundation_visualization",
        "display_name": "building_inundation_visualization",
        // "vmin": 0,
        // "vmax": 1,
        // "cmap_colors": ['#0000FF', '#FF0000'],
        "colormap": { "0": "#0000FF", "1": "#FF0000" },
        "gcs_url": "https://storage.googleapis.com/tile-server-bucket/vijaywada-event-1/building_inundation_visualization.tif",
        "bounds": [80.56698665126918, 16.48649975218137, 80.7054224601241, 16.59340995058957]
    },
    {
        "tiff_name": "building_footprint",
        "display_name": "building_footprint",
        "colormap": { "-9999": "#FFFFFF", "0": "#000000", "1": "#000000", "2": "#000000" },
        "gcs_url": "https://storage.googleapis.com/tile-server-bucket/vijaywada-event-1/building_footprint.tif",
        "bounds": [80.56698665126918, 16.48649975218137, 80.7054224601241, 16.59340995058957]
    },
    {
        "tiff_name": "event_roads",
        "display_name": "event_roads",
        // "vmin": 0,
        // "vmax": 1,
        // "cmap_colors": ['#0000FF', '#FF0000'],
        "colormap": { "0": "#0000FF", "1": "#FF0000" },
        "gcs_url": "https://storage.googleapis.com/tile-server-bucket/vijaywada-event-1/event_roads.tif",
        "bounds": [80.56698665126918, 16.48649975218137, 80.7054224601241, 16.59340995058957]
    },
    {
        "tiff_name": "non_coherent_roads",
        "display_name": "non_coherent_roads",
        // "vmin": 1,
        // "vmax": 1,
        // "cmap_colors": ['#800080'],
        "colormap": { "1": "#800080" },
        "gcs_url": "https://storage.googleapis.com/tile-server-bucket/vijaywada-event-1/non_coherent_roads.tif",
        "bounds": [80.56698665126918, 16.48649975218137, 80.7054224601241, 16.59340995058957]
    },
    {
        "tiff_name": "coherent_roads",
        "display_name": "coherent_roads",
        // "vmin": 1,
        // "vmax": 1,
        // "cmap_colors": ['#FF0000'],
        "colormap": { "1": "#FF0000" },
        "gcs_url": "https://storage.googleapis.com/tile-server-bucket/vijaywada-event-1/coherent_roads.tif",
        "bounds": [80.56698665126918, 16.48649975218137, 80.7054224601241, 16.59340995058957]
    },
    {
        "tiff_name": "all_roads",
        "display_name": "all_roads",
        // "vmin": 1,
        // "vmax": 1,
        // "cmap_colors": ['#000000'],
        "colormap": { "1": "#000000" },
        "gcs_url": "https://storage.googleapis.com/tile-server-bucket/vijaywada-event-1/all_roads.tif",
        "bounds": [80.56698665126918, 16.48649975218137, 80.7054224601241, 16.59340995058957]
    },
    {
        "tiff_name": "inundation_mask",
        "display_name": "inundation_mask",
        // "vmin": 0,
        // "vmax": 255,
        // "cmap_colors": ['#FFFFFF', '#0000FF'],
        "colormap": { "0": "#FFFFFF", "255": "#0000FF" },
        "gcs_url": "https://storage.googleapis.com/tile-server-bucket/vijaywada-event-1/inundation_mask.tif",
        "bounds": [80.56698665126918, 16.48649975218137, 80.7054224601241, 16.59340995058957]
    },
    {
        "tiff_name": "urban_mask",
        "display_name": "urban_mask",
        // "vmin": 50,
        // "vmax": 50,
        // "cmap_colors": ['#A52A2A'],
        "colormap": { "50": "#A52A2A" },
        "gcs_url": "https://storage.googleapis.com/tile-server-bucket/vijaywada-event-1/urban_mask.tif",
        "bounds": [80.56698665126918, 16.48649975218137, 80.7054224601241, 16.59340995058957]
    },
    {
        "tiff_name": "crop_mask",
        "display_name": "crop_mask",
        // "vmin": 40,
        // "vmax": 40,
        // "cmap_colors": ['#FFFF00'],
        "colormap": { "40": "#FFFF00" },
        "gcs_url": "https://storage.googleapis.com/tile-server-bucket/vijaywada-event-1/crop_mask.tif",
        "bounds": [80.56698665126918, 16.48649975218137, 80.7054224601241, 16.59340995058957]
    }
]